import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { ReadJustimentListPresentation } from "./components/ReadjustListPresentation";

export const ReadjustmentPage = (): JSX.Element =>{
	return (
		<AuthGuard>
			<Sidebar>
				<ReadJustimentListPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
